import { gql } from '@apollo/client'

export const FETCH_EHR_AVAILABLE_DATES_WITH_SLOTS = gql`
  query ehrAvailableDatesWithSlots(
    $appointmentKind: EhrAppointmentKind
    $providerKind: EhrAppointmentProviderKind
    $getHealthieInstanceKind: EhrGetHealthieInstanceKind
    $timeZone: String
    $providerId: ID
    $excludedProvidersHealthieIds: [ID!]
    $cadence: EhrAppointmentRecurrenceCadence
  ) {
    ehrAvailableDatesWithSlots(
      appointmentKind: $appointmentKind
      providerKind: $providerKind
      getHealthieInstanceKind: $getHealthieInstanceKind
      timeZone: $timeZone
      providerId: $providerId
      excludedProvidersHealthieIds: $excludedProvidersHealthieIds
      cadence: $cadence
    ) {
      dates {
        date
        slots {
          time
          providerId
        }
      }
      providers {
        ... on Coach {
          id
          coachId
          fullName
          bio
          photo
          credentials
          specialties {
            key
            name
          }
        }
      }
    }
  }
`
